/***
 * File name: infoController.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Personal Information
 * Controller tab in Annual Security Incident Report module
 *
 * This file defines all the input fields needed for the Personal Information
 * Controller tab
 *
 * Includes the ff:
 * - Tab number indicator
 * - Label of the collection
 * - optionQuery and optionName indicates the query params and collection name
 * for fetching additional data from the server
 * - children includes all the input fields in the form
 * - formActions indicate all the action buttons to be included on top of the form
 * - Other configurations for the form
 *
 */
export default function (vm) {
  return {
    tab: 1,
    label: 'ASIR',
    optionQuery: {
    },
    optionName: [],
    children: [
      {
        is: 'v-row',
        vShow: vm.operation !== 'view',
        vBind: {
          class: 'mt-0'
        },
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'DateComponent',
                formKey: 'year',
                vBind: {
                  dateClass: 'required-field font-weight-bold text-body-1',
                  value: vm.formItem.year,
                  label: 'Year',
                  placeholder: 'YYYY',
                  min: '2001',
                  max: '2040',
                  openPickerOnClick: true,
                  yearOnly: true,
                  exactLength: 4,
                  disabled: false,
                  dense: true,
                  id: 'year',
                  vOnTextField: {
                    blur: () => vm.$v.formItem.year.$touch(),
                    input: () => vm.$v.formItem.year.$touch()
                  },
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        vShow: vm.operation === 'view',
        vBind: {
          class: 'mt-0'
        },
        properties: {
          justify: 'center'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Year',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'year',
                vBind: {
                  disabled: true,
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  solo: true,
                  flat: true,
                  id: 'year',
                  readonly: vm.readOnly
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Sector Name',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'sectorName',
                vBind: {
                  isDense: true,
                  class: 'font-weight-bold text-body-1',
                  id: 'sector',
                  name: 'sector',
                  allowFetch: vm.formItem.sector,
                  query: { type: 'sector' },
                  itemText: 'value',
                  canEdit: false,
                  disabled: true,
                  clearable: false,
                  solo: true,
                  flat: true,
                  appendIcon: ''
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Sub-Sector Name',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'subSectorName',
                vBind: {
                  isDense: true,
                  class: 'font-weight-bold text-body-1',
                  id: 'sector',
                  name: 'sector',
                  allowFetch: vm.formItem.sector,
                  query: { jurisdiction: vm.formItem.sector },
                  itemText: 'value',
                  canEdit: false,
                  disabled: true,
                  clearable: false,
                  appendIcon: '',
                  solo: true,
                  flat: true
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        vShow: vm.operation !== 'view',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'LookUpSelect',
                formKey: 'sectorName',
                vBind: {
                  label: 'Sector Name',
                  isDense: true,
                  id: 'sector',
                  name: 'sector',
                  itemText: 'value',
                  itemValue: '_id',
                  canEdit: false,
                  class: 'font-weight-bold text-body-1',
                  disabled: true,
                  outlined: true,
                  clearable: false,
                  appendIcon: ''
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0'
            },
            children: [
              {
                is: 'LookUpSelect',
                formKey: 'subSectorName',
                vBind: {
                  label: 'Sub-Sector Name',
                  isDense: true,
                  id: 'sector',
                  name: 'sector',
                  allowFetch: vm.formItem.sectorName,
                  query: { jurisdiction: vm.formItem.sectorName },
                  itemText: 'value',
                  canEdit: false,
                  class: 'font-weight-bold text-body-1',
                  disabled: true,
                  outlined: true,
                  clearable: false,
                  appendIcon: ''
                }
              }
            ]
          }
        ]
      },
      // 3rd
      {
        is: 'v-row',
        vShow: vm.operation !== 'view',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'city',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'City / Municipality',
                  dense: true,
                  id: 'city',
                  disabled: vm.readOnly,
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly
                },
                vOn: {
                  input: () => { vm.$v.formItem.city.$touch() },
                  blur: () => { vm.$v.formItem.city.$touch() }
                }

              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'pic',
                vBind: {
                  label: 'PIC',
                  name: 'organization',
                  id: 'organization',
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        vShow: vm.operation === 'view',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'City / Municipality',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'city',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  solo: true,
                  flat: true,
                  id: 'city',
                  readonly: vm.readOnly
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 4
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'PIC',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'pic',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  solo: true,
                  flat: true,
                  id: 'pic',
                  readonly: vm.readOnly
                }
              }
            ]
          }
        ]
      },

      // summary header
      {
        is: 'v-row',
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'd-flex'
            },

            children: [
              {
                is: 'h2',
                header: true,
                vText: 'Summary of Security Incidents and Privacy Breaches',
                vBind: {
                  style: 'color: #162b54'
                }
              },
              {
                is: 'span',
                header: true,
                vText: 'Please do not input negative values.*',
                vBind: {
                  class: 'ml-3'
                }
              }
            ]
          }
        ]
      },
      // fraud
      {
        is: 'v-row',
        vShow: vm.operation !== 'view',
        vBind: {
          class: 'pb-0'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'mandatoryBreachNotification',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  type: 'number',
                  label: 'A. Mandatory Breach Notification',
                  dense: true,
                  id: 'mandatoryBreachNotification',
                  readonly: vm.readOnly,
                  min: 0,
                  oninput: 'validity.valid||(value="")',
                  outlined: !vm.readOnly
                },
                vOn: {
                  input: () => { vm.$v.formItem.mandatoryBreachNotification.$touch() },
                  blur: () => { vm.$v.formItem.mandatoryBreachNotification.$touch() }
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'voluntaryBreachNotification',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1',
                  label: 'B. Voluntary Data Breach Notification',
                  dense: true,
                  id: 'voluntaryBreachNotification',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  min: 0,
                  type: 'number',
                  oninput: 'validity.valid||(value="")'
                },
                vOn: {
                  input: () => { vm.$v.formItem.voluntaryBreachNotification.$touch() },
                  blur: () => { vm.$v.formItem.voluntaryBreachNotification.$touch() }
                }

              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        vShow: vm.operation === 'view',
        vBind: {
          class: 'pb-0'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'A. Mandatory Breach Notification',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'mandatoryBreachNotification',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  solo: true,
                  flat: true,
                  id: 'mandatoryBreachNotification',
                  readonly: vm.readOnly
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'B. Voluntary Data Breach Notification',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'voluntaryBreachNotification',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  solo: true,
                  flat: true,
                  id: 'voluntaryBreachNotification',
                  readonly: vm.readOnly
                }
              }
            ]
          }
        ]
      },
      // unauthorized
      {
        is: 'v-row',
        vShow: vm.operation !== 'view',
        vBind: {
          class: 'pb-0'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'summaryOthers',
                vBind: {
                  class: 'required-field font-weight-bold text-body-1 mb-1',
                  label: 'C. Other Security Incidents',
                  dense: true,
                  type: 'number',
                  min: 0,
                  id: 'summaryOthers',
                  readonly: vm.readOnly,
                  outlined: !vm.readOnly,
                  oninput: 'validity.valid||(value="")'
                },
                vOn: {
                  input: () => { vm.$v.formItem.summaryOthers.$touch() },
                  blur: () => { vm.$v.formItem.summaryOthers.$touch() }
                }

              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'v-text-field',
                formKey: 'total',
                vBind: {
                  label: 'Total Security Incidents',
                  dense: true,
                  id: 'total',
                  class: 'font-weight-bold text-body-1',
                  disabled: true,
                  outlined: !vm.readOnly
                }
              }
            ]
          }
        ]
      },
      {
        is: 'v-row',
        vShow: vm.operation === 'view',
        vBind: {
          class: 'pb-0'
        },
        children: [
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'C. Other Security Incidents',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'summaryOthers',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  solo: true,
                  flat: true,
                  id: 'summaryOthers',
                  readonly: vm.readOnly
                }
              }
            ]
          },
          {
            is: 'v-col',
            vBind: {
              class: 'pb-0',
              cols: 6
            },
            children: [
              {
                is: 'span',
                header: true,
                vText: 'Total Security Incidents',
                vBind: {
                  class: 'pl-3 gray--text font-weight-bold'
                }
              },
              {
                is: 'v-text-field',
                formKey: 'total',
                vBind: {
                  class: 'font-weight-bold text-body-1',
                  dense: true,
                  disabled: true,
                  solo: true,
                  flat: true,
                  id: 'total',
                  readonly: vm.readOnly
                }
              }
            ]
          }
        ]
      }
    ],
    formActions: []
  }
}
